let newsSlider = "";

function initNewsSlider() {
    newsSlider = $('.js-news-slider').slick({
        dots: false,
        variableWidth: false,
        slidesToShow: 3.6,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 520,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                },
            },
        ]
    });
}

$(document).ready(function() {
    if ($('.js-news-slider').length > 0) {
        initNewsSlider();
    }
});


// WEBPACK FOOTER //
// ./src/js/pages/main/news.js